(function () {
    'use strict';

    angular.module('swif.interventions')
    .service('openstcResourcesService', openstcResourcesService)
    .component('openstcResourcesSelected', {
        templateUrl: 'partials/openstc/resources_selected.html',
        controller: OpenstcResourcesTabsetController,
        bindings: {
            onChange: '&'
        }
    })
    .component('openstcResourcesTabset', {
        templateUrl: 'partials/openstc/resources_tabset.html',
        controller: OpenstcResourcesTabsetController,
        bindings: {
            onChange: '&'
        }
    });


    /**
     * this service resolve the data with the router
     * data are use by the two components
     */
    function openstcResourcesService($q, swif, openbase) {
        'ngInject';
        var service = {
            is_parcauto: false,
            countResources: 0,
            onChangeCallback: {},
            currentCollection: 'officers',
            current: {
                officers: [],
                team: undefined,
                serviceSupplier: undefined
            },
            userColor: {},
            teamColor: {},
            resolveData: resolveData,
            loadUserColors: loadUserColors,
            loadTeamColors: loadTeamColors,
            setCurrentOfficer: setCurrentOfficer,
            toggleOfficer: toggleOfficer,
            setCurrentTeam: setCurrentTeam,
            setCurrentServiceSupplier: setCurrentServiceSupplier,
            isOfficierSelected: isOfficierSelected,
            selectCollection: selectCollection,
            getCurrent: getCurrent
        };
        return service;
        function _onChange(data) {
            _.forOwn(service.onChangeCallback, function (value, key) {
                value(data);
            });
        }
        function loadUserColors(filter) {
            var copy = angular.copy(filter);
            copy.limit = 0;
            copy.fields = ['id', 'hex_color'];
            swif.data.searchRead('user', copy)
            .then(function (users) {
                _.forEach(users.records, function (user) {
                    if (user.hex_color) {
                        service.userColor[user.id] = user.hex_color;
                    }
                });
            });
        }

        function loadTeamColors(filter) {
            var copy = angular.copy(filter);
            copy.limit = 0;
            copy.fields = ['id', 'color'];
            swif.data.searchRead('team', copy)
            .then(function (teams) {
                _.forEach(teams.records, function (team) {
                    if (team.color) {
                        service.teamColor[team.id] = team.color;
                    }
                });
            });
        }

        function resolveData (data) {
            data.countResources = 0;
            var options = {
                is_parcauto: service.is_parcauto
            };
            var officerFilter = swif.user.getManageableOfficersFilter(true, options);
            officerFilter.limit = 10;
            service.loadUserColors(officerFilter);
            var p_officers = swif.collections.createOrUpdate(
                'manageable_officers', 'user', officerFilter
            ).then(function (collection) {
                service.officers = collection;
                service.countResources += collection.currentCount;
                if (data) {
                    data.officers = collection;
                    data.countResources += collection.currentCount;
                }
            });

            var teamFilter = swif.user.getManageableTeamsFilter(true, options);
            teamFilter.limit = 10;
            service.loadTeamColors(teamFilter);
            var p_teams = swif.collections.createOrUpdate(
                'manageable_teams', 'team', teamFilter
            ).then(function (collection) {
                service.teams = collection;
                service.countResources += collection.currentCount;
                service.tooltipTeamMembers = {};
                if (data) {
                    data.teams = collection;
                    data.countResources += collection.currentCount;
                    data.tooltipTeamMembers = {};
                }
                //TODO: load members name;
                _.forEach(collection.items, function (team) {
                    var buffer = '';
                    _.forEach(team.user_names, function (member) {
                        if (buffer !== '') {
                            buffer += ', ';
                        }
                        buffer += member[1];
                    });
                    service.tooltipTeamMembers[team.id] = buffer;
                    if (data) {
                        data.tooltipTeamMembers[team.id] = buffer;
                    }
                });
            });

            var service_suppliers_filter = openbase.partner.getServiceSuppliersFilter({}, 'planning');
            service_suppliers_filter.limit = 10;
            var p_suppliers = swif.collections.createOrUpdate(
                'service_suppliers', 'partner', service_suppliers_filter
            ).then(function (collection) {
                service.service_suppliers = collection;
                service.countResources += collection.currentCount;
                if (data) {
                    data.service_suppliers = collection;
                    data.countResources += collection.currentCount;
                }
            });

            return $q.all([
                p_officers,
                p_teams,
                p_suppliers
            ]).then(function () {
                return data;
            });
        }

        function setCurrentOfficer(officer) {
            delete service.current.team;
            delete service.current.serviceSupplier;
            if (_.isNumber(officer) || _.isString(officer)) {
                officer = {id: officer};
            }
            //We check if we know this guy using the userColor
            if (!_.contains(_.keys(service.userColor), officer.id.toString())) {
                return;
            }
            var found = false;
            var i,o;
            for (i = 0; i < service.current.officers.length; i++) {
                o = service.current.officers[i];
                if (o.id === officer.id) {
                    found = true;
                }
            }
            if (!found) {
                swif.data.get('user', officer.id)
                .then(function (officer) {
                    service.current.officers.push(officer);
                    _onChange();
                });
            }
        }

        function toggleOfficer (officer) {
            var found = false;
            if (!officer) {
                return;
            }
            var i,o;
            for (i = 0; i < service.current.officers.length; i++) {
                o = service.current.officers[i];
                if (o.id === officer.id) {
                    var index = service.current.officers.indexOf(o);
                    service.current.officers.splice(index, 1);
                    found = true;
                    _onChange();
                    break;
                }
            }
            if (!found) {
                setCurrentOfficer(officer);
            }
        }

        function setCurrentTeam(team) {
            var found = false;
            if (service.current.team) {
                if (service.current.team.id === team.id) {
                    found = true;
                }
            }
            if (found) {
                delete service.current.team;
            } else {
                service.current.team = team;
            }
            service.current.officers = [];
            delete service.current.serviceSupplier;
            _onChange();
        }

        function setCurrentServiceSupplier (service_supplier) {
            var found = false;
            if (service.current.serviceSupplier) {
                if (service.current.serviceSupplier.id === service_supplier.id) {
                    found = true;
                }
            }
            if (found) {
                delete service.current.serviceSupplier;
            } else {
                service.current.serviceSupplier = service_supplier;
            }
            service.current.officers = [];
            delete service.current.team;
            _onChange();
        }

        function isOfficierSelected (id) {
            var found = false;
            _.forEach(service.current.officers, function (o) {
                if (o.id === id) {
                    found = true;
                }
            });
            return found;
        }

        //mean you focus on that collection 'officiers' / ...
        function selectCollection(id) {
            switch (id) {
            case 'officers':
                service.current.team = undefined;
                service.current.serviceSupplier = undefined;
                break;
            case 'teams':
                service.current.team = undefined;
                break;
            case 'service_suppliers':
                service.current.serviceSupplier = undefined;
                break;
            default:
            }
            if (id !== service.currentCollection) {
                service.currentCollection = id;
                _onChange();
            }
        }

        function getCurrent() {
            var current = {};
            if (!_.isEmpty(service.current.officers)) {
                current.officers = service.current.officers;
                service.current.allOfficers = false;
            } else if (service.current.team) {
                current.team = service.current.team;
            } else if (service.current.serviceSupplier) {
                current.serviceSupplier = service.current.serviceSupplier;
            } else {
                switch (service.currentCollection) {
                case 'officers':
                    if (_.has(service.officers, 'items')) {
                        current.officers = service.officers.items;
                        current.allOfficers = true;
                    }
                    break;
                case 'teams':
                    if (_.has(service.teams, 'items')) {
                        current.team = service.teams.items;
                    }
                    break;
                case 'service_suppliers':
                    if (_.has(service.service_suppliers, 'items')) {
                        current.serviceSupplier = service.service_suppliers.items;
                    }
                    break;
                default:
                }
            }
            return current;
        }
    }

    function OpenstcResourcesTabsetController($scope, openstcResourcesService) {
        'ngInject';
        var service = openstcResourcesService;
        $scope.officers = service.officers;
        $scope.teams = service.teams;
        $scope.service_suppliers = service.service_suppliers;
        $scope.tooltipTeamMembers = service.tooltipTeamMembers;
        $scope.current = service.current;

        $scope.isOfficierSelected = service.isOfficierSelected;
        $scope.toggleOfficer = service.toggleOfficer;
        $scope.setCurrentOfficer = service.setCurrentOfficer;
        $scope.setCurrentTeam = service.setCurrentTeam;
        $scope.setCurrentServiceSupplier = service.setCurrentServiceSupplier;
        $scope.resourceTabSelected = service.currentCollection;
        $scope.selectResourceTab = selectResourceTab;

        //attache outputs to the service;
        service.onChangeCallback.directive = $scope.$ctrl.onChange;
        $scope.$on('destroy', function() {
            service.onChangeCallback.directive = undefined;
        });

        function selectResourceTab (collectionId) {
            service.selectCollection(collectionId);
        }
    }

})();
